<script lang="ts">
    import { _ } from "svelte-i18n"
    import { baseURL, mail, socialMedia } from "../../configs/config"
    import { location } from "../../store"
    interface Props {
        createdAt?: Date | string
        updatedAt?: Date | string
        article?: boolean
        blog?: boolean
        FAQ?: boolean
        FAQDetails?: {
            question?: string
            answer?: string
        }[]
        metaDescription?: string
        title?: string
    }
    let {
        createdAt = new Date(),
        updatedAt = new Date(),
        article = false,
        blog = false,
        FAQ = false,
        FAQDetails = [],
        metaDescription = "",
        title = "",
    }: Props = $props()

    createdAt = new Date(createdAt).toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })
    updatedAt = new Date(updatedAt).toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })

    const defaultProps = {
        author: {
            "@id": `${baseURL}/#company`,
        },
        publisher: {
            "@id": `${baseURL}/#company`,
        },
        inLanguage: {
            "@type": "Language",
            name: "German",
        },
        datePublished: createdAt,
        dateModified: updatedAt,
        isPartOf: {
            "@id": `${baseURL}/#website`,
        },
    }

    const schemaOrgEntity = {
        "@type": ["Store", "Organization"],
        "@id": `${baseURL}/#company`,
        name: $_("general.companyName"),
        url: baseURL,
        email: mail,

        image: {
            "@type": "ImageObject",
            "@id": `${baseURL}/#image`,
            inLanguage: {
                "@type": "Language",
                name: "German",
            },
            contentUrl: `${baseURL}/api/_/assets/logo/dark.png`,
            width: 576,
            height: 158,
            caption: "Stiftung Familienunternehmen und Politik Logo",
        },
        logo: {
            "@type": "ImageObject",
            "@id": `${baseURL}/#logo`,
            url: baseURL,
            contentUrl: `${baseURL}/api/_/assets/logo/dark.png`,
            caption: "Stiftung Familienunternehmen und Politik Logo",
            inLanguage: {
                "@type": "Language",
                name: "German",
            },
        },
        priceRange: "$$",
        location: {
            "@id": location,
        },
        sameAs: [socialMedia.x, socialMedia.linkedIn],
    }

    const schemaOrgWebsite = {
        "@type": "WebSite",
        "@id": `${baseURL}/#website`,
        url: baseURL,
        name: $_("general.companyName"),
        ...defaultProps,
    }

    const schemaOrgWebPage = {
        "@type": "WebPage",
        "@id": `${$location.url}#webpage`,
        url: $location.url,
        name: title,
        ...defaultProps,
        description: metaDescription,

        potentialAction: [
            {
                "@type": "ReadAction",
                target: [$location.url],
            },
        ],
    }

    let schemaOrgArticle = null
    if (article || blog) {
        schemaOrgArticle = {
            "@type": "Article",
            "@id": `${$location.url}#article`,
            headline: title,
            description: metaDescription,
            ...defaultProps,
            articleSection: ["blog"],
        }
    }

    let schemaOrgBlog = null
    if (blog) {
        schemaOrgBlog = {
            "@type": "BlogPosting",
            "@id": `${$location.url}#blog`,
            headline: title,
            description: metaDescription,
            ...defaultProps,
        }
    }

    let schemaOrgFAQ = null
    if (FAQ) {
        schemaOrgFAQ = {
            "@type": "FAQPage",
            "@id": `${$location.url}#faq`,
            ...defaultProps,
            mainEntity: FAQDetails.map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: faq.answer,
                },
            })),
        }
    }

    const schemaOrgArray = [
        schemaOrgEntity,
        schemaOrgWebsite,
        schemaOrgWebPage,
        schemaOrgFAQ,
        schemaOrgArticle,
        schemaOrgBlog,
    ].filter(Boolean)
    const schemaOrgObject = {
        "@context": "https://schema.org",
        "@graph": schemaOrgArray,
    }
    let jsonLdString = JSON.stringify(schemaOrgObject)
    let jsonLdScript = `
		<script type="application/ld+json">
			${jsonLdString}
		${"<"}/script>
	`
</script>

<svelte:head>
    {@html jsonLdScript}
</svelte:head>
